import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import Navbar from "../Components/Navbar";
import "../Styles/ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/password-reset-request`, {
        email,
      });
      setMessage(response.data.message);
      // Optionally redirect to login page after a short delay
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.detail || "Password reset failed");
    }
  };

  return (
    <div className="forgot-password-container">
      <Navbar />
      <div className="form-container">
        <h2 className="forgot-password-title">Reset Your Password</h2>
        {error && <p className="forgot-password-error">{error}</p>}
        {message && <p className="forgot-password-message">{message}</p>}
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email:</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn">
            Send Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
